// PIN-verified state helper.
// Stores the last-verified timestamp in localStorage (survives browser close)
// instead of sessionStorage (which wipes on every browser close).
// Validity window is enforced by isPinStillValid below.

const PIN_VALIDITY_MINUTES = 30;

const STORAGE_KEY = "student_pin_verified_at";

export function markPinVerified() {
  localStorage.setItem(STORAGE_KEY, Date.now().toString());
}

export function isPinStillValid() {
  const verifiedAt = localStorage.getItem(STORAGE_KEY);
  if (!verifiedAt) return false;
  const ts = parseInt(verifiedAt, 10);
  if (Number.isNaN(ts)) return false;
  const elapsedMinutes = (Date.now() - ts) / 1000 / 60;
  return elapsedMinutes < PIN_VALIDITY_MINUTES;
}

export function clearPinVerification() {
  localStorage.removeItem(STORAGE_KEY);
}
